import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import { Auth } from "aws-amplify";

import { AppContext } from "./libs/contextLib";
import Routes from "./Routes";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const history = useHistory();
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    try {
      await Auth.currentSession();
      userHasAuthenticated(true);
    } catch (e) {
      if (e !== "No current user") {
        alert(e);
      }
    }
    setIsAuthenticating(false);
  }

  async function handleLogout() {
    await Auth.signOut();
    userHasAuthenticated(false);
    history.push("/login");
  }

  return (
    !isAuthenticating && (
      <div className="App container-fluid">
        <Navbar className="mb-2" expand="lg">
          <Navbar.Brand href="/">
            <img
              alt=""
              src="/android-chrome-192x192.png"
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{" "}
            <b>TKSL Media</b>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {isAuthenticated ? (
              <Nav>
                <Nav.Item>
                  <LinkContainer to="/videoLinks">
                    <Nav.Link>Video Links</Nav.Link>
                  </LinkContainer>
                </Nav.Item>
              </Nav>
            ) : (
              <></>
            )}

            <Nav className="ml-auto" activeKey="/home">
              {isAuthenticated ? (
                <>
                  <Nav.Item onClick={handleLogout}>
                    <Nav.Link>Logout</Nav.Link>
                  </Nav.Item>
                </>
              ) : (
                <>
                  <Nav.Item>
                    <LinkContainer to="/login">
                      <Nav.Link>Login</Nav.Link>
                    </LinkContainer>
                  </Nav.Item>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
          <Routes />
        </AppContext.Provider>
      </div>
    )
  );
}

export default App;
